import React, { useEffect } from "react";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { makeSideBarActive } from "../../utils/EllowUtils";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import { useState } from "react";
import Styles from "./styles.module.scss";
import { viewedpageMixpanel } from "../../utils/mixpanel";
import UploadHistoryTable from "./UploadHistoryTable";
import { uploadHistory } from "./services";

function UploadHistory() {
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2);
  const BreadcrumsValues = ["Upload History"];
  const [sort, setSort] = useState<any>([]);
  const [data, setData] = useState<any>([]);
  const [total, setTotal] = useState<any>([]);
  
  useEffect(() => {
    getuploadHistory(25, 1, '', '', '')
    viewedpageMixpanel();
  }, []);

  const getuploadHistory = (pageSize: number, pageNumber: number, searchValue: string, filter?: any, sort?: any) => {
    uploadHistory(pageSize, pageNumber, searchValue, filter, sort).then((response: any) => {
      if (response && response.status === "success") {
        setData(response.data);
        setTotal(response.count);
      }
    });
  };



  const searchChange = (e: string) => {

  };

  const closeTag = (data: any) => {
    let value = {
      filters: data,
    };
    applyFilter(value);
  };

  const applyFilter = (data: any) => {
    // setFilterValues(data.filters);

  };
  const handleUpload = () => { };

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} openresource={"publicdatabase"} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyResourceFilter={applyFilter}
          searchChange={searchChange}
          closeTag={closeTag}


        />

        <section>
          <div className={Styles.tableWrapper}>
            <UploadHistoryTable
              data={data}
              total={total}
              contractHistory={{}}
              handlePageChange={{}}
              getTablesValues={() => { }}
              onClick={() => { }}
            />
          </div>
        </section>

      </div>
    </section>
  );
}

export default UploadHistory;
